import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset, isOpen, onClose }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const followerRanges = [
    { value: 'all', label: 'Tüm Takipçiler' },
    { value: '1k-10k', label: '1K - 10K' },
    { value: '10k-50k', label: '10K - 50K' },
    { value: '50k-100k', label: '50K - 100K' },
    { value: '100k-500k', label: '100K - 500K' },
    { value: '500k+', label: '500K+' }
  ];

  const engagementRanges = [
    { value: 'all', label: 'Tüm Etkileşim Oranları' },
    { value: '1-3', label: '%1 - %3' },
    { value: '3-5', label: '%3 - %5' },
    { value: '5-8', label: '%5 - %8' },
    { value: '8+', label: '%8+' }
  ];

  const contentTypes = [
    { value: 'video', label: 'Video İçerik' },
    { value: 'story', label: 'Hikaye' },
    { value: 'post', label: 'Gönderi' },
    { value: 'reel', label: 'Reel' },
    { value: 'live', label: 'Canlı Yayın' }
  ];

  const platforms = [
    { value: 'instagram', label: 'Instagram' },
    { value: 'tiktok', label: 'TikTok' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'twitter', label: 'Twitter' }
  ];

  const demographics = [
    { value: '13-17', label: '13-17 Yaş' },
    { value: '18-24', label: '18-24 Yaş' },
    { value: '25-34', label: '25-34 Yaş' },
    { value: '35-44', label: '35-44 Yaş' },
    { value: '45+', label: '45+ Yaş' }
  ];

  const handleLocalChange = (key, value) => {
    setLocalFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onFilterChange(localFilters);
    if (onClose) onClose();
  };

  const handleReset = () => {
    const resetFilters = {
      followerRange: 'all',
      engagementRange: 'all',
      contentTypes: [],
      platforms: [],
      demographics: [],
      minPrice: '',
      maxPrice: '',
      verified: false
    };
    setLocalFilters(resetFilters);
    onReset();
    if (onClose) onClose();
  };

  const filterContent = (
    <div className="space-y-6">
      <div>
        <Select
          label="Takipçi Sayısı"
          options={followerRanges}
          value={localFilters?.followerRange}
          onChange={(value) => handleLocalChange('followerRange', value)}
        />
      </div>

      <div>
        <Select
          label="Etkileşim Oranı"
          options={engagementRanges}
          value={localFilters?.engagementRange}
          onChange={(value) => handleLocalChange('engagementRange', value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-foreground mb-3">
          İçerik Türleri
        </label>
        <div className="space-y-2">
          {contentTypes?.map((type) => (
            <Checkbox
              key={type?.value}
              label={type?.label}
              checked={localFilters?.contentTypes?.includes(type?.value)}
              onChange={(e) => {
                const newTypes = e?.target?.checked
                  ? [...localFilters?.contentTypes, type?.value]
                  : localFilters?.contentTypes?.filter(t => t !== type?.value);
                handleLocalChange('contentTypes', newTypes);
              }}
            />
          ))}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-foreground mb-3">
          Platformlar
        </label>
        <div className="space-y-2">
          {platforms?.map((platform) => (
            <Checkbox
              key={platform?.value}
              label={platform?.label}
              checked={localFilters?.platforms?.includes(platform?.value)}
              onChange={(e) => {
                const newPlatforms = e?.target?.checked
                  ? [...localFilters?.platforms, platform?.value]
                  : localFilters?.platforms?.filter(p => p !== platform?.value);
                handleLocalChange('platforms', newPlatforms);
              }}
            />
          ))}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-foreground mb-3">
          Demografik Hedef
        </label>
        <div className="space-y-2">
          {demographics?.map((demo) => (
            <Checkbox
              key={demo?.value}
              label={demo?.label}
              checked={localFilters?.demographics?.includes(demo?.value)}
              onChange={(e) => {
                const newDemo = e?.target?.checked
                  ? [...localFilters?.demographics, demo?.value]
                  : localFilters?.demographics?.filter(d => d !== demo?.value);
                handleLocalChange('demographics', newDemo);
              }}
            />
          ))}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-foreground mb-3">
          Fiyat Aralığı (₺)
        </label>
        <div className="grid grid-cols-2 gap-3">
          <Input
            type="number"
            placeholder="Min"
            value={localFilters?.minPrice}
            onChange={(e) => handleLocalChange('minPrice', e?.target?.value)}
          />
          <Input
            type="number"
            placeholder="Max"
            value={localFilters?.maxPrice}
            onChange={(e) => handleLocalChange('maxPrice', e?.target?.value)}
          />
        </div>
      </div>

      <div>
        <Checkbox
          label="Sadece Doğrulanmış Hesaplar"
          checked={localFilters?.verified}
          onChange={(e) => handleLocalChange('verified', e?.target?.checked)}
        />
      </div>

      <div className="flex gap-3 pt-4 border-t border-border">
        <Button
          variant="outline"
          fullWidth
          onClick={handleReset}
        >
          Sıfırla
        </Button>
        <Button
          variant="default"
          fullWidth
          onClick={handleApply}
        >
          Uygula
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Filter Panel */}
      <div className="hidden lg:block w-80 bg-card border border-border rounded-lg p-6 h-fit sticky top-20">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-foreground">Filtreler</h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleReset}
          >
            Temizle
          </Button>
        </div>
        {filterContent}
      </div>

      {/* Mobile Filter Panel */}
      {isOpen && (
        <div className="lg:hidden fixed inset-0 z-[1300] bg-background/80 backdrop-blur-sm">
          <div className="fixed inset-y-0 right-0 w-full max-w-sm bg-card shadow-elevation-3 overflow-y-auto">
            <div className="sticky top-0 bg-card border-b border-border p-4 flex items-center justify-between z-10">
              <h2 className="text-lg font-semibold text-foreground">Filtreler</h2>
              <Button
                variant="ghost"
                size="icon"
                onClick={onClose}
              >
                <Icon name="X" size={20} />
              </Button>
            </div>
            <div className="p-6">
              {filterContent}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterPanel;